/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

import { useTrackingContext } from "../../analytics";
import { BlockDetailsCard, BlockInformation, Header } from "../../components";
import { TRACKING_CONTEXT } from "../../constants";
import { useAppProviderContext } from "../../context/appProvider";
import {
  accountSubTypeDetails,
  getInvestorType,
  prepareModalPopupInfo,
  trackButtonOrToggle,
  trackProcess,
  trackView,
} from "../../helpers";
import { useIBModalPopup } from "../../hooks";
import { IModalData, IOtherFlexCard } from "../../interfaces";

const OtherFlexCard: React.FC<IOtherFlexCard> = (props: IOtherFlexCard) => {
  const { headerInfo, cardInfo, blockInfo } = props;
  const { actions, state } = useAppProviderContext();
  const track = useTrackingContext();
  const { accountTypeValue } =
    accountSubTypeDetails[cardInfo.accountSubTypeCode];

  const [isPrimaryButtonClicked, setIsPrimaryButtonClicked] = useState(false);
  const { showModalPopup } = useIBModalPopup(setIsPrimaryButtonClicked);

  const isDeclineAllState =
    cardInfo?.isDeclineAll && !cardInfo?.impulseDelayRemaining;
  const investorType = getInvestorType(cardInfo?.investorTypeCode);

  const trackBlockChange = (
    pageName: string,
    toggleText: string,
    interactionType: string,
    navigationType: string,
    navigationIdentifier: string = pageName
  ) => {
    trackButtonOrToggle(
      track,
      pageName,
      `${cardInfo?.customerNumber}`,
      toggleText,
      interactionType,
      navigationType,
      navigationIdentifier
    );
  };

  const handleBlockChange = () => {
    if (cardInfo?.impulseDelayRemaining) {
      trackBlockChange(
        TRACKING_CONTEXT.PAGE.CONFIRM_BLOCK,
        TRACKING_CONTEXT.DYNAMIC_MESSAGE.TOGGLE_ON_TEXT,
        TRACKING_CONTEXT.DYNAMIC_MESSAGE.BUTTON_INTERACTION,
        TRACKING_CONTEXT.NAVIGATION_TYPE.PRIMARY_BUTTON,
        cardInfo?.cardStaticContent?.cardInfo?.leave_block_on
      );
    } else if (isDeclineAllState) {
      trackBlockChange(
        TRACKING_CONTEXT.PAGE.CONFIRM_UNBLOCK,
        TRACKING_CONTEXT.DYNAMIC_MESSAGE.TOGGLE_OFF_TEXT,
        TRACKING_CONTEXT.DYNAMIC_MESSAGE.TOGGLE_INTERACTIONS,
        TRACKING_CONTEXT.NAVIGATION_TYPE.TOGGLE_SWITCH
      );
    } else {
      trackBlockChange(
        TRACKING_CONTEXT.PAGE.CONFIRM_BLOCK,
        TRACKING_CONTEXT.DYNAMIC_MESSAGE.TOGGLE_ON_TEXT,
        TRACKING_CONTEXT.DYNAMIC_MESSAGE.TOGGLE_INTERACTIONS,
        TRACKING_CONTEXT.NAVIGATION_TYPE.TOGGLE_SWITCH
      );
    }
    const popupInfo: IModalData = prepareModalPopupInfo(
      state,
      isDeclineAllState
    );
    showModalPopup(popupInfo);
  };

  const trackPageViewAndProcess = (pageName: string) => {
    trackView(track, pageName, `${cardInfo.customerNumber}`);
    trackProcess(track, pageName, accountTypeValue, investorType);
  };

  useEffect(() => {
    let pageName = TRACKING_CONTEXT.PAGE.NOT_BLOCKED;
    if (cardInfo?.impulseDelayRemaining) {
      pageName = TRACKING_CONTEXT.PAGE.UNBLOCK_PENDING;
    } else if (isDeclineAllState) {
      pageName = TRACKING_CONTEXT.PAGE.BLOCKED;
    }
    trackPageViewAndProcess(pageName);
  }, [cardInfo]);

  useEffect(() => {
    if (isPrimaryButtonClicked) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      actions.setGamblingControl(
        state.startupData?.account[0]?.tokenisedPan as string,
        !isDeclineAllState
      );
    }
  }, [isPrimaryButtonClicked]);

  return (
    <>
      <Header {...headerInfo} />
      <BlockDetailsCard
        {...cardInfo}
        handleBlockStatusChange={handleBlockChange}
      />
      <BlockInformation
        showGamCareLink={
          cardInfo.isDeclineAll && !cardInfo.impulseDelayRemaining
        }
        {...blockInfo}
      />
    </>
  );
};

export default OtherFlexCard;
